// HomeButtonUI.js
var HomeButtonUi = pc.createScript('homeButtonUi');

HomeButtonUi.attributes.add('HomeEnt', { type: 'entity' });
HomeButtonUi.attributes.add('CloseBtn', { type: 'entity' });
HomeButtonUi.attributes.add('ReturnMenuBtn', { type: 'entity' });
HomeButtonUi.attributes.add('SpawnManagerView', { type: 'entity' });
HomeButtonUi.attributes.add('shakeButton', { type: 'entity' });
HomeButtonUi.attributes.add('jokerButton', { type: 'entity' });

// initialize code called once per entity
HomeButtonUi.prototype.initialize = function () {

    HomeButtonUi.instance = this;
    this.isHomeButtonIsCliked = false;
    this.buttonsinit();

    this.app.on('gameManager:gamePlayMode', this.Status, this);
    this.entity.on("destroy", function () {
        this.app.off('gameManager:gamePlayMode', this.Status, this);
    }, this);
};

HomeButtonUi.prototype.Status = function (playMode) {

    let homeButtonTexture = null;

    if (playMode == gamePlayMode.Normal || playMode == gamePlayMode.Places) {
        this.entity.setLocalPosition(new pc.Vec3(-439.199, -128.265, 0));
        this.entity.children[1].enabled = true;
        this.entity.children[0].enabled = true;
        this.entity.element.width = 200;
        this.entity.element.height = 76;
        homeButtonTexture = this.app.assets.findByTag("homeButtonGame");
    }

    else if (playMode == gamePlayMode.MiniGame) {

        this.entity.setLocalPosition(new pc.Vec3(-439.545, -115, 0));
        this.entity.children[1].enabled = false;
        this.entity.children[0].enabled = false;
        this.entity.element.width = 230;
        this.entity.element.height = 187;
        homeButtonTexture = this.app.assets.findByTag("homeButtonEvent");
    }

    if (homeButtonTexture[0].resource) {
        if (playMode == gamePlayMode.Normal) {
            this.entity.element.spriteAsset = homeButtonTexture[0];
        }
        else if (playMode == gamePlayMode.MiniGame) {
            this.entity.element.texture = homeButtonTexture[0].resource;
        }

    }
    else {
        homeButtonTexture[0].on("load", function (asset) {
            HomeButtonUi.instance.entity.element.texture = asset.resource;
        });

        this.app.assets.load(homeButtonTexture[0]);
    }
};

HomeButtonUi.prototype.showHomePanel = function () {

    this.SpawnManagerView.enabled = false;
    Timer.instance.PauseTimer();
    TimeBar.instance.pauseBar();
    Touch.instance.Pause();
    ScoreManager.instance.isPaused();
    this.HomeEnt.enabled = true;
};

HomeButtonUi.prototype.buttonsinit = function () {

    this.entity.button.on('click', function (event) {

        this.SpawnManagerView.enabled = false;
        //GameManager.instance.PauseGame();

        this.isGamePaused = true;
        SoundManager.instance.pauseSound();
        Touch.instance.Pause();
        Timer.instance.PauseTimer();
        TimeBar.instance.pauseBar();
        this.app.fire('gameManager:updatestatus', gamestatus.Pause);

        ScoreManager.instance.isPaused();
        this.HomeEnt.enabled = true;

        if (PlayerManager.instance.levelData.levelName != "Donut Shop") {
            this.shakeButton.enabled = false;
        }

        if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
            this.jokerButton.enabled = false;
        }

    }, this);


    this.CloseBtn.button.on('click', function (event) {

        this.SpawnManagerView.enabled = true;
        GameManager.instance.ResumeGame();
        ScoreManager.instance.isContinue();
        this.HomeEnt.enabled = false;

            
        if (PlayerManager.instance.levelData.levelName != "Donut Shop") {
            this.shakeButton.enabled = true;
        }

        if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
            this.jokerButton.enabled = true;
        }

    }, this);

    this.ReturnMenuBtn.button.on('click', function (event) {

        if (this.isHomeButtonIsCliked == false) {
            this.isHomeButtonIsCliked = true;
            var customFields;

            if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal || PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {

                if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {

                    customFields = {
                        "LevelName": PlayerManager.instance.levelData.levelName,
                        "UserRank": detectCurrentLevel()[0]
                    };
                }
                else {
                    customFields = {
                        "LevelName": GameManager.instance.placeData.levelName,
                        "UserRank": detectCurrentLevel()[0]
                    };
                }
                if (GameAnalyticsSdk.instance.gaStatus) { GameAnalytics("addDesignEvent", "ExitGameButton:Click", 1, customFields); }
            }
            else if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {

                let miniGameTheme = playingMiniGameName == "Attention Game" ? GameManager.instance.eventData.matchKey.toString().replaceAll(',', '-') : GameManager.instance.eventData.matchKey;

                customFields = {
                    "MiniGameName": playingMiniGameName,
                    "MiniGameTheme": miniGameTheme,
                };
                if (GameAnalyticsSdk.instance.gaStatus) { GameAnalytics("addDesignEvent", "ExitMiniGameButton:Click", 1, customFields); }
            }

            if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {


                if (PlayerManager.instance.levelData.levelName != "Donut Shop") {
                    clearCacheFunction();

                    PlayerManager.instance.userData.roomAssets = [...roomObjectList];
                    PlayerManager.instance.userData.lastTimeProgressBar = progressVal;
                    PlayerManager.instance.userData.savedMatchedObjectCount = matchObjectCounter;
                    PlayerManager.instance.userData.interruption = 1;
                    PlayerManager.instance.SavePlayerData();
                    PlayerManager.instance.SaveLevelData();

                }
            }
            else if (PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {
                showPlaceModUI = true;
            }
            Timer.instance.StopTimer();
            ScoreManager.instance.isContinue();
            loadScene(`Menu`, { hierarchy: true, settings: true });
        }


    }, this);
};



